import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessagesService } from '../messages/messages.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AccessToken } from './access-token';
import { AuthUtil } from './auth-util';
import { RefreshAuthenticationService } from './access-token-refresh';

// Interceptor to inetrcept requests and appends Access token as Bearer token
@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

  constructor(private messagesService: MessagesService, private router: Router,private refreshAuthenticationService:RefreshAuthenticationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authUtil=new AuthUtil();
    let accessToken = authUtil.getAccessToken()
    if (accessToken) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + accessToken)
      });
    }
     
    if(accessToken && authUtil.isLoginExpired())
    {
    alert('Your login expired ! We are logging you out')
    authUtil.logout()
    }
    if (accessToken && !AccessToken.isInProgress && authUtil.isLoginGoingToExpireIn30min()) {
      AccessToken.isInProgress = true;
      this.extendToken();
    }
    return next.handle(request).pipe(tap((response: HttpEvent<any>) => {
    }, (err: any) => {
     
      
    }))
  }
  
  extendToken() {
    let authUtil = new AuthUtil()

    this.refreshAuthenticationService.requestForAccessTokenUsingRefreshToken(authUtil.getRefreshToken())
      .subscribe(token => {
        let current_date = new Date()
        current_date.setSeconds(current_date.getSeconds() + token.expires_in)
        token.expire_at = current_date
        token.user_groups = authUtil.getRoleClaim(token.access_token)
        localStorage.setItem('token', JSON.stringify(token))
        AccessToken.isInProgress = false;
      }, error => {
        console.log('error in refreshing token ', error)
        authUtil.logout()
      })
  }

}